// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dLIM7{align-self:flex-start}.DIdBy{padding-inline-start:28px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkboxExplicitApproval": `dLIM7`,
	"statementInput": `DIdBy`
};
export default ___CSS_LOADER_EXPORT___;
